import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isUrl } from './image-uploader.utils';

@Component({
    selector: 'app-image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.component.scss'],
})
export class ImageUploaderComponent implements OnInit {
    @Input() image: string;
    @Input() showHint: boolean;
    @Input() disableDelete: boolean;
    @Input() key: string;

    @Output() onDelete: EventEmitter<void> = new EventEmitter();
    @Output() onReplace: EventEmitter<void> = new EventEmitter();
    @Output() onFileChange: EventEmitter<void> = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    isUrl(image) {
        return isUrl(image);
    }
}
